import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SlideMenuService {

  public slideMenuOpened = false;

  constructor() { }
}
